export default __webpack_public_path__ + "static/snacking-836ad57693157ac12baec7e97346de6c.svg";